import { ICommonState } from "../reducers/commonReducer";

export const selectLanguageResults = ({ common: { language } }: ICommonState) => language;

export const selectMarketingChannelResults = ({ common: { marketingChannel } }: ICommonState) =>
  marketingChannel;

export const selectRegionById = (regionId: number) => ({ common: { region } }: ICommonState) => {
  return region?.find((r: any) => r.id === regionId);
};

export const selectRegionResults = ({ common: { region } }: ICommonState) => region;

export const selectStoreTypeResults = ({ common: { storeType } }: ICommonState) => storeType;

export const selectFileFormatResults = ({ common: { fileFormat } }: ICommonState) => fileFormat;

export const selectAssetTypeResults = ({ common: { assetTypes } }: ICommonState) => assetTypes;

export const selectAssetDimensionResults = ({ common: { assetDimensions } }: ICommonState) =>
  assetDimensions;

export const selectAssetRequestResults = ({ common: { assetRequest } }: ICommonState) =>
  assetRequest;

export const selectCampaignBriefSearchResults = ({ common: { campaignBriefs } }: ICommonState) =>
  campaignBriefs;
